import { h, Fragment } from "preact";

export default function ProductCardSwatch({
  product,
  active,
  setActiveProductId,
}) {
  const image =
    product.swatchImage?.reference.image.url ||
    product.media[0]?.previewImage.url;

  const handleMouseEnter = () => {
    setActiveProductId(product.id);
  };

  return (
    <a
      className="product-card__swatch"
      href={product.helpers.url}
      onMouseEnter={handleMouseEnter}
      onFocus={handleMouseEnter}
      title={`${product.title} in ${product.helpers.color}`}
    >
      <img
        className={`product-card__swatch-image ${
          active ? "product-card__swatch-image--active" : ""
        } ${
          product.helpers.isLightColor
            ? "product-card__swatch-image--light"
            : ""
        }`}
        src={getSizedImageUrl(image, "x100")}
        role="presentation"
        alt={product.helpers.color}
      />
    </a>
  );
}
